import { PROTOCOL_STATUS } from "../constants/constants";
import * as R from "ramda";

export const sortList = (orderBy, orderDef) => {
  return (a, b) => {
    let reorder = 0;

    const paramA = R.path(R.split(".", orderBy), a);
    const paramB = R.path(R.split(".", orderBy), b);

    if (typeof paramA === "string" && typeof paramB === "string") {
      reorder = paramA.localeCompare(paramB);
    } else {
      if (paramA > paramB) reorder = 1;
      if (paramA < paramB) reorder = -1;
    }

    if (orderDef === "ASC") {
      return reorder;
    } else {
      return -reorder;
    }
  };
};

export const isRBEAuthor = (author) =>
  author ? author.match(/^(?:RBE)\d$/) : false;

export const getProtocolStatus = (answersList) => {
  if (!answersList || !answersList.length)
    return PROTOCOL_STATUS.AWAITING_ANSWER;

  const lastAnswer = R.pipe(
    R.sort(sortList("timestamp", "DESC")),
    R.head
  )(answersList);

  if (isRBEAuthor(lastAnswer.author)) return PROTOCOL_STATUS.ANSWERED;

  return PROTOCOL_STATUS.AWAITING_ANSWER;
};
